import { ToolCallSummary } from "./call";
import { ChatSummary } from "./chat";
import { MessageKind, MessageStatus, MessageType } from "./enums/message";
import { UserTiny } from "./user";

export interface SuggestedMessageSummary {
  id: string;
  chatId: string;
  fromMessageId: string;
  content: string;
  assistantId: string;
  isSelected: boolean;
  createdDate: string;
}

export interface PortalNotificationSummary {
  id: string;
  content?: string | null;
  status: MessageStatus;
  errorMessage?: string | null;
  createdDate: string;
}

export interface MessageSummary {
  id: string;
  messageUid?: string | null;
  content?: string | null;
  chatId: string;
  status: MessageStatus;
  errorMessage?: string | null;
  sendoMessageId?: string | null;
  sender: UserTiny;
  functionCall?: { [key: string]: any } | null;
  createdDate: string;
  files?: string[] | null;
  suggestedMessages?: SuggestedMessageSummary[] | null;
  toolCalls?: ToolCallSummary[] | null;
  eventId?: string | null;
  type?: MessageType | null;
  channel?: "sms" | "web_chat" | "patient_portal" | null;
  clinicPhoneNumberId?: string | null;
  /** Patient a clinic portal message is addressed to. */
  recipientPatientId?: string | null;
  recipientPatientName?: string | null;
  /** The SMS that told the patient about this portal message, if one went out. */
  portalNotification?: PortalNotificationSummary | null;
}

export interface MessageWithChatSummary {
  message: MessageSummary;
  chat: ChatSummary;
}

export interface MessageCreate {
  id?: string | null;
  chatId: string;
  messageUid: string;
  content?: string | null;
  senderId: string;
  sendoMessageId?: string | null;
  status?: MessageStatus;
  files?: string[] | null;
  eventId?: string | null;
  type?: MessageType | null;
  clinicPhoneNumberId?: string | null;
}

/** Explicit intent: editing message text never changes its contact semantics. */
export type MessageContext =
  | { kind: MessageKind.DEFAULT; quoteId?: string }
  | {
      kind: MessageKind.EVENT;
      eventId: string;
      messageType?: Exclude<MessageType, MessageType.WAITLIST>;
      quoteId?: string;
    }
  | { kind: MessageKind.WAITLIST; waitlistEntryIds: [string, ...string[]] };

export function getContextMessageType(
  context: MessageContext,
): MessageType | undefined {
  return context.kind === MessageKind.WAITLIST
    ? MessageType.WAITLIST
    : context.kind === MessageKind.EVENT
      ? context.messageType
      : undefined;
}
